import {useParams} from "react-router-dom";
import Card from "../../../../components/Card.jsx";
import React from "react";
import {useModificaBatch} from "./useModificaBatch";
import FormModificaBatch from "./components/FormModificaBatch";

export default function ModificaBatch() {
    const {idBatch} = useParams();

    const {
        getBottoniSx,
        getBottoniDx,
        title,
        batch,
        formikRef,
    } = useModificaBatch({idBatch});

    return (
        <Card
            icon={'fas fa-tasks'}
            title={title}
            getBottoniSx={getBottoniSx}
            getBottoniDx={getBottoniDx}
        >
            <FormModificaBatch
                batch={batch}
                idBatch={idBatch}
                formikRef={formikRef}
            />
        </Card>
    );
}